import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { PROCESS_TAG_CONFIG, ProcessTag } from '@/types/process.types';

type ProcessTagBadgeProps = {
  tag: string | null;
  className?: string;
};

export const ProcessTagBadge = ({ tag, className }: ProcessTagBadgeProps) => {
  if (!tag) {
    return null;
  }

  const isValidTag = Object.values(ProcessTag).includes(tag as ProcessTag);
  if (!isValidTag) {
    return null;
  }

  const config = PROCESS_TAG_CONFIG[tag as ProcessTag];

  return (
    <Badge
      className={cn(
        'shrink-0 border px-1.5 py-0 font-medium text-[10px] leading-4',
        config.className,
        className
      )}
      variant="outline"
    >
      {config.label}
    </Badge>
  );
};
